// `{|}` in a seed prompt marks where the caret should land; `\n\n` becomes a paragraph break.
export const CURSOR_MARKER = '{|}';

const escapeHtml = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const parseSeedText = (text: string): { html: string; cursorPos: number | null } => {
  const markerIdx = text.indexOf(CURSOR_MARKER);
  if (markerIdx < 0) return { html: text, cursorPos: null };
  const clean = text.replace(CURSOR_MARKER, '');
  const html = clean
    .split('\n\n')
    .map(p => `<p>${escapeHtml(p)}</p>`)
    .join('');
  // Each `\n\n` separator (2 chars) lines up with the close+open boundary between
  // tiptap paragraphs, so the clean-text offset maps directly to the tiptap pos.
  return { html, cursorPos: 1 + markerIdx };
};
